module.exports = __webpack_public_path__ + "static/slide-3-9f3b095ad0096f61fe74c6555c641189.png";